import { merge } from "timm";
import { Pagination } from "../../types/Pagination";

export default function generatePaginationForEachPage(
  pagination: Pagination,
): Pagination[] {
  return [...Array(pagination.last)].map((_, index) => {
    const current = index + 1;
    const next = index + 2 > pagination.last ? pagination.last : index + 2;
    const initialBlock =
      current === pagination.first || current - pagination.first <= 0
        ? "initial"
        : "";
    const middleBlock =
      current >= pagination.current - 1 && current <= pagination.current + 1
        ? "middle"
        : "";
    const lastBlock =
      current === pagination.last || pagination.last - current <= 0
        ? "last"
        : "";

    return merge(pagination, {
      current,
      next,
      block: initialBlock || middleBlock || lastBlock,
    }) as Pagination;
  });
}
